/**
 * /frontend/src/features/analytics/hooks/useStaffingAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getStaffingEfficiency, getStaffingForecast, getStaffingScheduleRecommendation } from '../api/staffingAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads staffing analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useStaffingAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, days, date, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [forecast, efficiency, schedule] = await Promise.all([
      getStaffingForecast(request, storeToken, storeUuid, days),
      getStaffingEfficiency(request, storeToken, storeUuid, startDate, endDate),
      getStaffingScheduleRecommendation(request, storeToken, storeUuid, date),
    ]);
    return { forecast, efficiency, schedule };
  }, [date, days, endDate, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useStaffingAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useStaffingAnalytics;
